<template lang="pug">

header.main-header
  img(:src="header.mouserlogo")

</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "MouserGeneralHeader",
  computed: {
    ...mapGetters(["header", "errorMessage"]),
  },
  methods: {
    ...mapMutations(["setErrorMessage"]),
  },
};
</script>

<style lang="scss" scoped>
.main-header {
  display: flex;
  gap: 1.25rem 2rem;
  margin: 0 0 0rem;
  flex-direction: column;
  @include mq(lg) {
  margin: 0 0 0rem;
    flex-direction: row;
  }
}
.bm-header {
  a {
    color: #004E7D;
  }
}

img {
  align-self: center;
  height:10vh;
  @include mq(lg) {
    flex: 0 1 250px;
    //min-width: 100px;
  }
}

div {
  position: relative;
  display: flex;
  @include mq(lg) {
    padding: 0.25rem 0;
    &::before {
      content: "";
      width: 1px;
      background: lighten($midGray, 10%);
      position: relative;
      left: -1.125rem;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  small::v-deep *:last-child {
    margin-bottom: 0;
  }
}
</style>

